import FileName from '../ComControl/FileName'
import AvgButtonIndex from '../ComControl/AvgButtonIndex'
import AvgButton from '../ComControl/AvgButton'
import { FileReader, FileWriter } from '@/platform'

class GameMenuData {
    /**
     * 系统菜单背景图
     */
    public BackPic: FileName = new FileName()

    /**
     * 系统菜单按钮集合 project_bin_no
     */
    public Buttons: Array<AvgButton> = []

    /**
     * 系统菜单按钮索引集合
     */
    public ButtonsEx: Array<AvgButtonIndex> = []

    /**
     * 按钮索引 project_bin_no
     */
    public BIndex: Array<number> = []

    /**
     * 是否使用自有坐标 project_bin_no
     */
    public IsFree: boolean = false

    /**
     * 按钮呼叫页面索引集合
     */
    public callUIList: Array<number> = []

    constructor(btns?: AvgButton[]) {
        if (btns !== undefined) {
            this.BackPic = new FileName({ type: FileName.DEF_TYPE, name: 'gameMenu.png' })
            this.Buttons = btns
            this.BIndex = [26, 27, 28, 29, 30, 31]
            this.ButtonsEx = new Array<AvgButtonIndex>(this.BIndex.length)
            for (let i: number = 0; i < this.BIndex.length; i++) {
                this.ButtonsEx[i] = new AvgButtonIndex(
                    this.BIndex[i],
                    this.Buttons[i]?.X,
                    this.Buttons[i]?.Y
                )
            }
        }
    }

    /** cg_v3_data：BackPic → Buttons → ButtonsEx → BIndex → IsFree（callUIList 非 bin 字段） */
    readBin(reader: FileReader): void {
        this.BackPic = new FileName(reader)

        this.Buttons = []
        const btnLen = reader.readInt()
        for (let i = 0; i < btnLen; i++) {
            const b = new AvgButton()
            b.readBin(reader)
            this.Buttons.push(b)
        }

        this.ButtonsEx = []
        const exLen = reader.readInt()
        for (let i = 0; i < exLen; i++) {
            const avgIndexBtn = new AvgButtonIndex()
            avgIndexBtn.readBin(reader)
            this.ButtonsEx.push(avgIndexBtn)
        }

        this.BIndex = []
        const biLen = reader.readInt()
        for (let i = 0; i < biLen; i++) {
            this.BIndex.push(reader.readInt())
        }

        this.IsFree = reader.readBool()
    }

    writeBin(writer: FileWriter): void {
        this.BackPic.writeBin(writer)
        writer.writeInt(this.Buttons.length)
        for (let i = 0; i < this.Buttons.length; i++) {
            this.Buttons[i]!.writeBin(writer)
        }
        writer.writeInt(this.ButtonsEx.length)
        for (let i = 0; i < this.ButtonsEx.length; i++) {
            this.ButtonsEx[i]!.writeBin(writer)
        }
        writer.writeInt(this.BIndex.length)
        for (let i = 0; i < this.BIndex.length; i++) {
            writer.writeInt(this.BIndex[i]!)
        }
        writer.writeBool(this.IsFree)
    }

    readVersionedOui(reader: FileReader): void {
        this.BackPic.readVersionedOui(reader.readObj(reader.readInt()))

        let avgIndexLen = reader.readInt()
        for (let i = 0; i < avgIndexLen; i++) {
            let avgIndexBtn = new AvgButtonIndex()
            avgIndexBtn.readVersionedOui(reader.readObj(reader.readInt()))
            this.ButtonsEx.push(avgIndexBtn)
        }
    }

    writeVersionedOui(writer: FileWriter): void {
        writer.writerIntLength()

        this.BackPic.writeVersionedOui(writer)

        writer.writeInt(this.ButtonsEx.length)
        for (let i = 0; i < this.ButtonsEx.length; i++) {
            const avgBtnIndex = this.ButtonsEx[i]
            avgBtnIndex.writeVersionedOui(writer)
        }

        writer.writerLength()
    }

    writeGameBin(writer: FileWriter): void {
        this.writeVersionedOui(writer)
    }
}
export default GameMenuData
